import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {addEditEntityTypeReady} from '../redux/entity_types'
import apiService from '../services/apiservices'
import { headerDataUpdate,subHeaderDataUpdate, buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'
//import  {ValidateEmail ,ValidatePhone,isLatitude,isLongitude} from '../../../common/ValidationFunctions/CommonValidation'


//import {CostCenters,Employees} from './DropDowns/index'


import {EntityTypesCombo} from '../../../common/DropDowns/index'

//import * as Helpers from '../../../common/helpers'

class AddEditEntityType extends Component {

  constructor() {
    super()
    this.state = {

        bodyHeight: "0px",
        editFlag:false,

        entityTypeName: "",
        remarks: "",
        type: "",
        entityTypeData:{},

       entityTypeNameErrorText: false,
       entityTypeNameErrorData: '',

        remarksErrorText: false,
        remarksErrorData: '',

        typeErrorText: false,
        typeErrorData: '',

        subTitle: Constants.ADD_ENTITY_TYPE

    }

    this.isComponentStillMounted = true

    this.entityTypeNameComponent = null
    this.entityTypeNameSection = null

    this.remarksComponent = null
    this.remarksSection = null


    this.typeComponent = null
    this.typeSection = null

    

}

componentWillMount() {
    this.isComponentStillMounted = true
    this.props.dispatch(addEditEntityTypeReady(false))

    if (this.props.entity_types && this.props.entity_types.entityTypesSelectedId && this.props.entity_types.entityTypesSelectedId !== null) {
        this.props.dispatch(headerDataUpdate(Constants.EDIT_ENTITY_TYPE))
        this.setState({
            subTitle: "Edit Entity Type",
            editFlag:true
        })
    } else {
        this.props.dispatch(headerDataUpdate(Constants.ADD_ENTITY_TYPE))
        this.setState({
            subTitle: "Add Entity Type"
        })
    }
    this.props.dispatch(subHeaderDataUpdate())

    window.addEventListener("resize", this.updateDimensions)
    this.updateDimensions()


    if (this.props.entity_types && this.props.entity_types.entityTypesSelectedId && this.props.entity_types.entityTypesSelectedId !== null) {
        this.getEntityTypeById(this.props.entity_types.entityTypesSelectedId)
    }else{

    this.props.dispatch(addEditEntityTypeReady(true))
    }
}

componentDidMount() {

        this.entityTypeNameSection = ReactDOM.findDOMNode(this.refs.entityTypeNameSection)

        this.remarksSection = ReactDOM.findDOMNode(this.refs.remarksSection)

        this.typeSection = ReactDOM.findDOMNode(this.refs.typeSection)

}

updateDimensions = () => {
    if (window.innerWidth <= 767) {
        this.setState({
            bodyHeight: (window.innerHeight - 130) + "px",
        })
    } else {
        this.setState({
            bodyHeight: (window.innerHeight - 100) + "px",
        })
    }
}

validateBuildNumber = (data) => {
    if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
        if (this.props.user.build_number === data.app_build_no) {
            //do smthng here
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    } else {
        this.props.dispatch(buildNumberUpdate(data.app_build_no))
        window.location.reload()
    }
}

componentWillUnmount() {
    this.isComponentStillMounted = false
    window.removeEventListener("resize", this.updateDimensions)
}


mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === "") {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}

onSaveClick = () => {

    this.props.dispatch(addEditEntityTypeReady(false))
    let data = {}

    let entityTypeNameObject = this.mandateValidation("entityTypeName", Constants.FORM_INPUT)
    if (entityTypeNameObject.status) {
        data.name = this.entityTypeNameComponent.value
    } else {

         this.props.dispatch(addEditEntityTypeReady(true))
        return
    }



    let typeObject = this.mandateValidation("type", Constants.FORM_SELECT)
    if (typeObject.status) {
        data.entity_name = this.typeComponent.value
    } else {
        this.props.dispatch(addEditEntityTypeReady(true))
        return
    }

    data.remarks = this.remarksComponent.value


    let apiPayloadData=data;


    if(this.state.editFlag){


        apiService.editEntityType(apiPayloadData,this.state.entityTypeData.id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditEntityTypeReady(true))
                        this.props.history.push("/dashboard/entityTypes/list")
                    } else {

                        this.props.dispatch(addEditEntityTypeReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditEntityTypeReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }else{

    apiService.addEntityType(apiPayloadData)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditEntityTypeReady(true))
                        this.props.history.push("/dashboard/entityTypes/list")
                    } else {

                        this.props.dispatch(addEditEntityTypeReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditEntityTypeReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }


}

integerValidation = (value) => {
    if (/\D/.test(value)) {
        return true
    } else {
        return false
    }
}

onCancelClick = () => {
    this.props.history.goBack()
}


getEntityTypeById = (id) => {
    apiService.getEntityTypeById(id)
        .then(responseData => {
            if (responseData.status === "SUCCESS") {

                if (responseData && responseData.data) {                   
                    this.setState({
                       entityTypeData: responseData.data ,
                        entityTypeName : responseData.data.name  ,
                        remarks : responseData.data.remarks ,
                        type : responseData.data.entity_name              
                    })

                    if (this.isComponentStillMounted) {
                        this.entityTypeNameComponent.value=responseData.data.name
                        this.typeComponent.value=responseData.data.entity_name
                        this.remarksComponent.value=responseData.data.remarks
                    }

                    this.props.dispatch(addEditEntityTypeReady(true))             

                }

            }


        })
        .catch(err => {
            console.error("Error data: ", err)
             this.props.dispatch(addEditEntityTypeReady(true))
        })
}




 remarkssChange = (data) => {
    this.remarksComponent.value=data.value
        this.setState({
            remarks :data.value,
            remarksErrorText: false,
            remarksErrorData: ''
        })
        this.remarksSection.className= this.remarksSection.className.replace(" has-error", "")
    }



 employeeChange = (data) => {
    this.headComponent.value=data.value
        this.setState({
            head :data.value,
            headErrorText: false,
            headErrorData: ''
        })
        this.headSection.className= this.headSection.className.replace(" has-error", "")
    }

    entityTypesComboChange = (data) => {
    
        this.typeComponent.value=data.value
            this.setState({
                type :data.value,
                typeErrorText: false,
                typeErrorData: ''
            })
            this.typeSection.className= this.typeSection.className.replace(" has-error", "")
    }



    




    render() {
        return (
            <div className="line-item-edit">

                <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>
                <Dialog ref={el => this.dialog = el} />
                <section className="content">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight }}>
                            <div className="box box-info" style={{ borderTop: "0px" }}>
                                <div className="box-header with-border">
                                    <h3 className="box-title" style={{ fontWeight: 600 }}>{this.state.subTitle}</h3>
                                </div>
                                <div className="form-horizontal">
                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.entityTypeNameSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Name *</label>
                                                    <div className="col-sm-9">
                                                        <input className="form-control" placeholder="Enter Name" type="text" ref={el => this.entityTypeNameComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("entityTypeName")}} />
                                                        <span className="help-block"style={{display: this.state.entityTypeNameErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.entityTypeNameErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                            



                                          <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el => this.typeSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Type *</label>
                                                    <div className="col-sm-9" ref={el => this.typeComponent = el}>
                                                        
                                                         <EntityTypesCombo entityTypesComboChange={this.entityTypesComboChange} selectedValue={this.state.type} />

                                                        <span className="help-block"style={{display: this.state.typeErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.typeErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>


                                          <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el => this.remarksSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Remarks </label>
                                                    <div className="col-sm-9">
                                                        

                                                        <textarea className="form-control" placeholder="Enter Remarks" type="text" ref={el => this.remarksComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("remarks")}} />
                                                         
                                                        <span className="help-block"style={{display: this.state.remarksErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.remarksErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>


                                        
                                            
                                                </div>
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            </div>
                                        </div>

                                    </div>

                                    <div className="box-footer">
                                        <button
                                            className="btn btn-default"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onCancelClick()
                                            }}>
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-info pull-right"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onSaveClick()
                                            }}>
                                            Save Changes
                                        </button>
                                    </div>
                                </div>
                    </div>
                </section>
            </div>
        )
    }

    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }

}
function mapStateToProps(state) {
    return {
        entity_types: state.entity_types,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(AddEditEntityType))


// WEBPACK FOOTER //
// ./src/modules/Entity Types/Components/AddEditEntityType.js